import RangeSlider from './RangeSlider'
export type { SliderRewardProps } from './RangeSlider'

export default RangeSlider
